"use strict";
/*
 * Dyna node network - Dyna Node client
 * (c) Anel development - http://www.anel.co
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var dyna_crypt_1 = require("dyna-crypt");
var dyna_job_queue_1 = require("dyna-job-queue");
var dyna_interfaces_1 = require("dyna-interfaces");
var dyna_loops_1 = require("dyna-loops");
var dyna_object_assign_1 = require("dyna-object-assign");
var dyna_retry_1 = require("dyna-retry");
var DynaNodeMessage_1 = require("../DynaNodeMessage/DynaNodeMessage");
var DynaNodeAddress_1 = require("../DynaNodeAddress/DynaNodeAddress");
var AcknowledgeManager_1 = require("./AcknowledgeManager");
var createConnection_1 = require("./createConnection");
var envGlobal_1 = require("../utils/envGlobal");
var isCommand_1 = require("../utils/isCommand");
var unknownError_1 = require("../utils/unknownError");
var consoleStringify_1 = require("../utils/consoleStringify");
var createDynamicDynaNodeAddress_1 = require("../utils/createDynamicDynaNodeAddress");
var DEFAULT_replyTimeoutInMs = 30000;
var DEFAULT_retryConfig = {
    operation: function () { return Promise.resolve(); },
    maxRetries: 5,
    retryTimeoutBaseMs: 500,
    increasePercentFrom: 20,
    increasePercentTo: 60,
    retryTimeoutMaxMs: 0.5 * 60 * 1000,
};
var DynaNodeClient = /** @class */ (function () {
    function DynaNodeClient(config) {
        var _this = this;
        this._connections = {};
        this._validIncomingServerAddresses = {};
        this._messagesToSend = {};
        this._queue = new dyna_job_queue_1.DynaJobQueue();
        /**
         * Send new message providing to, command, data etc. Expected replies could be 0 (none), 1 or multiple.
         * This is the core method to send a new message.
         * @param config Configuration to create and send message
         * returns: Promise with the create message.
         */
        this.send = function (config) {
            var message = new DynaNodeMessage_1.DynaNodeMessage();
            message.to = config.to;
            message.command = config.command;
            message.args = config.args;
            message.data = config.data;
            message.binaryData = config.binaryData;
            message.headers = __assign(__assign({}, _this.headers), config.headers);
            if (config.replyOfId) {
                message.replyOf = { id: config.replyOfId };
            }
            var operation = function () {
                return _this.sendMessage({
                    message: message,
                    onReply: config.onReply,
                    onReplyTimeout: config.onReplyTimeout,
                    multiReplies: config.multiReplies,
                    replyTimeoutInMs: config.replyTimeoutInMs,
                    addTraces: config.addTraces,
                });
            };
            if (config.retry || config.retryConfig) {
                return dyna_retry_1.retry(dyna_object_assign_1.dynaObjectAssign(DEFAULT_retryConfig, config.retryConfig, { operation: operation }));
            }
            else {
                return operation();
            }
        };
        this.connectionRelatedCommands = [
            'dyna-node/serverAddresses/request',
            'dyna-node/server/prefixConnectionId',
        ];
        this._config = __assign({ compressMessages: true, closeInactiveConnectionsInMinutes: 1, 
            // no fallback for onMessage, we want to console it
            onError: function () { return undefined; }, onConnectionClose: function () { return undefined; } }, (config || {}));
        this._acknowledgeManager =
            new AcknowledgeManager_1.AcknowledgeManager({
                dynaNodeClient: this,
                _debug_dynaNodeAckResolveAfter: this._config._debug_dynaNodeAckResolveAfter,
            });
        this.headers = this._config.headers || {};
        var prefixInternalDynamicAddress = this._config
            && this._config.prefixAddress
            && this._config.prefixAddress + '--'
            || '';
        this.internalDynamicAddress = "" + prefixInternalDynamicAddress + createDynamicDynaNodeAddress_1.createDynamicDynaNodeAddress() + "@i/internal/0";
        this._getConnection = this._queue.jobFactory(this._getConnection.bind(this));
    }
    /**
     * Sends a new message and resolves with response message's data.
     * If the response's command stats with "error" or on network error the promise is rejected with IError.
     * @param config: IDynaNodeClientFetchConfig
     * Returns: Promise with the response's data.
     */
    DynaNodeClient.prototype.fetch = function (config) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.send(__assign(__assign({}, config), { onReply: function (reply) {
                    if (isCommand_1.isCommandSuccess(reply.command)) {
                        resolve(reply.data);
                    }
                    else {
                        reject(reply.data ||
                            {
                                code: 1810191204,
                                section: 'DynaNodeClient/fetch',
                                message: "DynaNodeClient.fetch with command [" + config.command + "] returned error with no data. Check the data.replyMessage prop of this error. This is not error of dyna-node!",
                                data: {
                                    requestConfig: config,
                                    replyMessage: reply.viewSecure,
                                },
                            });
                    }
                }, onReplyTimeout: (function (sourceMessage) {
                    reject({
                        code: 1810211742,
                        section: 'DynaNodeClient/fetch/onReplyTimeout',
                        message: 'Reply timeout',
                        data: { sourceMessage: sourceMessage },
                    });
                }) }))
                .catch(reject); // cannot send the message, network error
        });
    };
    /**
     * Send a new message. Reply is expected, so the other side should respond within replyTimeoutInMs.
     * If the response's command stats with "error" or on network error the promise is rejected.
     * @param config IDynaNodeClientSendReceive
     * Returns: Promise resolved with the responded message or null for success send
     */
    DynaNodeClient.prototype.sendReceive = function (config) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.send(__assign(__assign({}, config), { multiReplies: false, onReply: function (reply) {
                    if (isCommand_1.isCommandSuccess(reply.command)) {
                        resolve(reply);
                    }
                    else {
                        reject(reply.data);
                    }
                }, onReplyTimeout: (function (sourceMessage) {
                    reject({
                        code: 1810211741,
                        section: 'DynaNodeClient/sendReceive/onReplyTimeout',
                        message: 'Reply timeout',
                        data: { sourceMessage: sourceMessage },
                    });
                }) }))
                .catch(reject); // cannot send the message, network error
        });
    };
    /**
     * Create and send a new message as reply another one.
     * @param sourceMessage: The source message to reply on.
     * @param config: Config IDynaNodeClientReplyMessage
     * Returns: Promise with the created reply message.
     */
    DynaNodeClient.prototype.reply = function (sourceMessage, config) {
        var _this = this;
        config = dyna_object_assign_1.dynaObjectAssign({
            updateReplyOf: true,
            updateReplyOfData: false,
        }, config);
        var replyMessage = sourceMessage.reply(__assign({ args: undefined, data: undefined }, config));
        var sendConfig = dyna_object_assign_1.dynaObjectAssign(config, { message: replyMessage });
        var operation = function () { return _this.sendMessage(sendConfig); };
        if (config.retry || config.retryConfig) {
            return dyna_retry_1.retry(dyna_object_assign_1.dynaObjectAssign(DEFAULT_retryConfig, config.retryConfig, { operation: operation }));
        }
        else {
            return operation();
        }
    };
    /**
     * Send a message that is already created (by new DynaNodeMessage or another way like reply())
     * This is the core method to send an already created message.
     * @param config IDynaNodeClientSendMessage
     * Returns: Promise with the given message.
     */
    DynaNodeClient.prototype.sendMessage = function (config) {
        var _this = this;
        var sendConfig = dyna_object_assign_1.dynaObjectAssign({
            multiReplies: false,
            replyTimeoutInMs: DEFAULT_replyTimeoutInMs,
        }, config);
        var operation = function () { return _this._sendEngine(sendConfig); };
        if (config.retry || config.retryConfig) {
            return dyna_retry_1.retry(dyna_object_assign_1.dynaObjectAssign(DEFAULT_retryConfig, config.retryConfig, { operation: operation }));
        }
        else {
            return operation();
        }
    };
    Object.defineProperty(DynaNodeClient.prototype, "stats", {
        get: function () {
            return {
                serverConnections: Object.keys(this._connections),
                repliesForMessages: dyna_loops_1.default.values(this._connections)
                    .reduce(function (messageIds, connection) {
                    messageIds = messageIds.concat(Object.keys(connection.replies));
                    return messageIds;
                }, []),
                connectionsWithActiveReplies: dyna_loops_1.default.keyValues(this._connections)
                    .reduce(function (output, keyValue) {
                    var connection = keyValue.value;
                    if (Object.keys(connection.replies).length) {
                        output[keyValue.key] = Object.keys(connection.replies);
                    }
                    return output;
                }, {}),
                acknowledge: this._acknowledgeManager.stats,
            };
        },
        enumerable: true,
        configurable: true
    });
    // Removes a reply call back generated from send method multipleReplies: true
    // Return true if the reply found and removed, and false the reply didn't exist
    // Important note:  After removeRepliesForMessage, if the sender send again reply/ies for this message, this will console error.
    DynaNodeClient.prototype.stopMultipleReplies = function (message) {
        return this.stopMultipleRepliesByMessageId(message.id);
    };
    DynaNodeClient.prototype.stopMultipleRepliesByMessageId = function (messageId) {
        var _this = this;
        var found = false;
        dyna_loops_1.default.forValues(this._connections, function (connectionItem) {
            if (connectionItem.replies[messageId]) {
                delete connectionItem.replies[messageId];
                found = true;
                _this._clearReplyTimeout(connectionItem, messageId);
                _this._updateConnectionForExpiration(connectionItem);
            }
        });
        return found;
    };
    DynaNodeClient.prototype.changeConnectionId = function (_a) {
        var _this = this;
        var serverDynaNodeAddress = _a.serverDynaNodeAddress, newConnectionId = _a.newConnectionId, encryptionKey = _a.encryptionKey, accessKey = _a.accessKey, requestExpirationInMinutes = _a.requestExpirationInMinutes;
        return new Promise(function (resolve, reject) {
            _this.sendReceive({
                to: serverDynaNodeAddress,
                command: 'dyna-node/server/changeConnectionId',
                retry: false,
                args: {
                    changeConnectionIdVersion: '2.3',
                    connectionId: newConnectionId,
                    security: dyna_crypt_1.encryptEx({ accessKey: accessKey }, encryptionKey, requestExpirationInMinutes || 0.5),
                },
            })
                .then(function (serverResponse) {
                if (serverResponse.command === 'ok') {
                    resolve();
                }
                else {
                    reject({
                        section: 'DynaNodeClient/changeConnectionId/response',
                        code: 38762464,
                        message: 'dyna node server denied to change the connection id',
                        data: { serverResponse: serverResponse, serverDynaNodeAddress: serverDynaNodeAddress, newConnectionId: newConnectionId },
                    });
                }
            })
                .catch(function (error) {
                reject({
                    section: 'DynaNodeClient/changeConnectionId/sendFailed',
                    code: 38762478,
                    message: 'Cannot send the request to the dyna node server',
                    error: error,
                });
            });
        });
    };
    // prefixConnectionId, is prefixing the connection id for a connection with a specific DynaNodeServer.
    // After a disconnection with the Server, the prefixConnectionId should be applied again manually (using this method).
    // Currently the prefixConnectionId is used most of it for debugging making cleaner the anonymous connection ids.
    DynaNodeClient.prototype.prefixConnectionId = function (_a) {
        var serverDynaNodeAddress = _a.serverDynaNodeAddress, prefixConnectionId = _a.prefixConnectionId;
        return this.sendReceive({
            to: serverDynaNodeAddress,
            command: 'dyna-node/server/prefixConnectionId',
            args: {
                prefixConnectionId: prefixConnectionId,
            },
        })
            .then(function (reply) {
            if (reply.command === 'ok')
                return undefined;
            throw {
                code: 1907271616,
                message: "Server cannot prefix this connection id",
            };
        })
            .catch(function (error) {
            throw {
                code: 1907271617,
                section: "DynaNodeClient/prefixConnectionId",
                data: {
                    serverDynaNodeAddress: serverDynaNodeAddress,
                    prefixConnectionId: prefixConnectionId,
                },
                error: error,
            };
        });
    };
    // Drops current connections and cleans pending Acknowledge.
    // It is like the service's .stop()
    // After the this the DynaNodeClient is still usable and
    //    on the same time the app can be terminated without pending timers or promises.
    DynaNodeClient.prototype.stopConnections = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(Object.keys(this._connections)
                            .map(function (serverAddress) { return _this._closeConnection(serverAddress, {
                            code: 1810191321,
                            section: 'DynaNodeClient/closeAllConnections',
                            message: 'Connection closed by request (this is not error)',
                            errorType: dyna_interfaces_1.EErrorType.APP,
                        }); }))];
                    case 1:
                        _a.sent();
                        this._acknowledgeManager.clear();
                        return [2 /*return*/];
                }
            });
        });
    };
    DynaNodeClient.prototype._debug_dropConnections = function () {
        return Promise.all(dyna_loops_1.default
            .values(this._connections)
            .map(function (connection) {
            if (!connection.connection)
                return;
            return connection.connection._debug_dropConnection();
        }))
            .then(function () { return undefined; });
    };
    DynaNodeClient.prototype._sendEngine = function (sendMessageConfig) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var toAddress = new DynaNodeAddress_1.DynaNodeAddress(sendMessageConfig.message.to);
            sendMessageConfig.message.addTracesIfEnabled(sendMessageConfig.addTraces);
            if (sendMessageConfig.message.to === _this.internalDynamicAddress) {
                _this._handleOnConnectionMessage(sendMessageConfig.message);
                resolve(sendMessageConfig.message);
                return;
            }
            if (!toAddress.isValid()) {
                reject({
                    code: 1910220851,
                    section: 'DynaNodeClient/_sendEngine',
                    errorType: dyna_interfaces_1.EErrorType.USER,
                    message: 'Message hasn\'t defined the recipient, or the \'to\' is not valid',
                    data: JSON.stringify({ message: sendMessageConfig.message.viewSecure }, null, 2),
                });
                return;
            }
            Promise.resolve()
                .then(function () {
                if (_this.connectionRelatedCommands.includes(sendMessageConfig.message.command))
                    return;
                return _this._getConnection(sendMessageConfig.message).then(function () { return undefined; });
            })
                .then(function () {
                sendMessageConfig.message._addTrace('DynaNode/Client/SEND_001', "DynaNode: DynaNodeClient, pushing message to queue send", _this._traceData);
                _this._messagesToSend[toAddress.serverAddress].push(__assign(__assign({}, sendMessageConfig), { resolve: resolve,
                    reject: reject }));
            })
                .then(function () { return _this._sendMessagesOfConnection(toAddress.serverAddress); })
                .catch(reject);
        });
    };
    DynaNodeClient.prototype._getConnection = function (message) {
        var _this = this;
        var toAddress = new DynaNodeAddress_1.DynaNodeAddress(message.to);
        if (!this._messagesToSend[toAddress.serverAddress])
            this._messagesToSend[toAddress.serverAddress] = [];
        var existedConnection = this._connections[toAddress.serverAddress];
        if (existedConnection)
            return Promise.resolve(existedConnection);
        var connectionItem = this._connections[toAddress.serverAddress] = {
            connection: null,
            isConnecting: true,
            lastTimeUsed: null,
            expirationTimeoutHandler: null,
            replies: {},
            serverAddresses: [],
        };
        // start the creation of the connection object
        return createConnection_1.createConnection.bind(this)({
            dynaNodeAddress: toAddress,
            prefixAddress: this._config.prefixAddress,
            onMessage: function (message) { return _this._handleOnConnectionMessage(message); },
            onConnectionClose: function () { return _this._handleOnConnectionClose(toAddress.serverAddress); },
            onError: this._config.onError && this._config.onError.bind(this) || undefined,
        })
            .then(function (connection_) {
            // connection was success, update the connection item
            connectionItem.connection = connection_;
            connectionItem.isConnecting = false;
        })
            .then(function () {
            return _this.fetch({
                to: toAddress.serverAddress,
                command: 'dyna-node/serverAddresses/request',
            })
                .then(function (serverAddresses) {
                connectionItem.serverAddresses = serverAddresses;
                serverAddresses.forEach(function (serverAddress) { return _this._validIncomingServerAddresses[serverAddress] = true; });
            })
                .catch(function (error) {
                throw {
                    section: 'DynaNodeClient/createConnection',
                    code: 1909050850,
                    message: "Connection with the server is done but cannot request for server's addresses",
                    error: error,
                };
            });
        })
            .then(function () {
            if (!_this._config.prefixAddress)
                return;
            return _this.prefixConnectionId({
                prefixConnectionId: _this._config.prefixAddress,
                serverDynaNodeAddress: toAddress.serverAddress,
            });
        })
            .then(function () { return connectionItem; })
            .catch(function (error) {
            // reject all messages and delete this connection, didn't work
            _this._closeConnection(toAddress.serverAddress, error)
                .catch(function (error) { return console.error("DynaNodeClient " + _this.consolePrefixAddress + ": 1810191405 cannot close connection (after failed send)", consoleStringify_1.consoleStringify(error)); });
            throw {
                section: 'DynaNodeClient/createConnection',
                code: 1911111145,
                message: 'Cannot establish and create connection with the target server',
                data: { message: message.viewSecure },
                error: error,
            };
        });
    };
    DynaNodeClient.prototype._sendMessagesOfConnection = function (serverAddress) {
        var _this = this;
        var connectionItem = this._connections[serverAddress];
        var messagesToSend = this._messagesToSend[serverAddress];
        if (!connectionItem.connection)
            return; // The Connection is not yet ready
        var _loop_1 = function () {
            var connectionMessage = messagesToSend.shift();
            if (!connectionMessage)
                return { value: void 0 };
            // update the replies (if needed)
            if (connectionMessage.onReply) {
                connectionItem.replies[connectionMessage.message.id] = {
                    onReply: connectionMessage.onReply,
                    onReplyTimeout: connectionMessage.onReplyTimeout,
                    multiReplies: connectionMessage.multiReplies,
                    replyTimeoutInMs: connectionMessage.replyTimeoutInMs,
                    deleteTimeoutTimer: null,
                };
                this_1._refreshReplyTimeout(connectionMessage.message, connectionItem, connectionMessage.message.id);
            }
            // debug monitor
            this_1._debug_dynaNode_monitorTransactions('out', connectionMessage.message);
            var willBeResolvedByAcknowledgeManager = this_1._acknowledgeManager.outgoingMessage(connectionMessage.message, connectionMessage.resolve, connectionMessage.reject);
            connectionMessage.message._addTrace('DynaNode/Client/SEND_002', 'DynaNode: DynaNodeClient: Sending message of connection', { clientPrefix: this_1._config.prefixAddress });
            // send
            connectionItem.connection.send(connectionMessage.message, !!this_1._config.compressMessages)
                .then(function (message) {
                if (!willBeResolvedByAcknowledgeManager)
                    connectionMessage.resolve(message);
            })
                .catch(function (error) {
                connectionMessage.reject(error || unknownError_1.unknownError(1810191202, 'DynaNodeClient/_sendMessagesOfConnection'));
            })
                .then(function () {
                _this._clearReplyTimeout(connectionItem, connectionMessage.message.id);
            });
            this_1._updateConnectionForExpiration(connectionItem);
        };
        var this_1 = this;
        while (messagesToSend.length) {
            var state_1 = _loop_1();
            if (typeof state_1 === "object")
                return state_1.value;
        }
    };
    DynaNodeClient.prototype._handleOnConnectionMessage = function (message) {
        var _this = this;
        var fromAddress = new DynaNodeAddress_1.DynaNodeAddress(message.from);
        var connectionItem = this._connections[fromAddress.serverAddress];
        message._addTrace("DynaNode/Client/RECEIVE_002 (client's last step)", 'DynaNode: DynaNodeClient incoming message', { clientPrefix: this._config.prefixAddress });
        if (fromAddress.address !== this.internalDynamicAddress
            && !this._validIncomingServerAddresses[fromAddress.serverAddress] // This is normal to be false on response of "dyna-node/serverAddresses/request"
            && !this._connections[fromAddress.serverAddress] // ... so check if this address is in connections already (the addition is done before the dyna-node/serverAddresses/request).
        ) {
            console.error("DynaNodeClient " + this.consolePrefixAddress + ": Security error 1912190908: The incoming message is suspicious since it's from address doesn't match from the server that it came from. For security reasons this message is discarded.", consoleStringify_1.consoleStringify({
                message: message.viewSecure,
                wrappedCommand: message.data && message.data.master && message.data.master.originalData && message.data.master.originalData.command,
                connections: Object.keys(this._connections),
                validServerAddresses: Object.keys(this._validIncomingServerAddresses),
            }));
            return;
        }
        this._debug_dynaNode_monitorTransactions('in', message);
        if (this._acknowledgeManager.incomingMessage(message)) {
            // Swallow the message, it was for the AcknowledgeManager
        }
        else if (message.replyOf && connectionItem && connectionItem.replies[message.replyOf.id]) {
            // there is callback waiting for this reply
            var reply_1 = connectionItem.replies[message.replyOf.id];
            if (reply_1.multiReplies) {
                this._refreshReplyTimeout(message, connectionItem, message.replyOf.id);
            }
            else {
                this._clearReplyTimeout(connectionItem, message.replyOf.id);
                delete connectionItem.replies[message.replyOf.id];
            }
            this._updateConnectionForExpiration(connectionItem);
            // Move the reply to the next circle. It is needed since the reply message would be received before the ACK confirmation, and this reply message is used to resolve the ACK!
            // We have to move it to the next circle because the AcknowledgeManager's resolve (by this message) is coming after this reply.onReply call.
            setTimeout(function () {
                reply_1.onReply(message, 
                // @ts-ignore
                function () { return _this.stopMultipleRepliesByMessageId(message.replyOf.id); });
            });
        }
        else if (this._config.onMessage) {
            this._config.onMessage(message);
        }
        else if (message.replyOf) {
            console.warn("DynaNodeClient " + this.consolePrefixAddress + ": 1809270723 The incoming message is reply of a message that is currently unknown.\n             This might be not a bug but indicates that something might be wrong in your app.\n             This can happen:\n             - if you you have called the stopMultipleReplies but the sender still sends messages (you have to get confirmation from the sender that it will stop sending to you any more)\n             - if you expect multiple messages from the recipient but you haven't set the multiReplies to true\n             - if the replyTimeoutInMs is expired (default is " + DEFAULT_replyTimeoutInMs + "), listen onReplyTimeout to track this\n             To handle these messages, implement the onMessage of the DynaNodeClient.\n          ", consoleStringify_1.consoleStringify({ message: message }));
        }
        else {
            console.error("DynaNodeClient " + this.consolePrefixAddress + ": 1809270724 The incoming message was unexpected (and it is suspicious)", consoleStringify_1.consoleStringify({ message: message.viewSecure }));
        }
    };
    DynaNodeClient.prototype._refreshReplyTimeout = function (sourceMessage, connectionItem, messageId) {
        this._clearReplyTimeout(connectionItem, messageId);
        connectionItem.replies[messageId].deleteTimeoutTimer = setTimeout(function () {
            if (connectionItem.replies[messageId] && connectionItem.replies[messageId].onReplyTimeout) {
                connectionItem.replies[messageId].onReplyTimeout(sourceMessage);
            }
            delete connectionItem.replies[messageId];
        }, connectionItem.replies[messageId].replyTimeoutInMs);
    };
    DynaNodeClient.prototype._clearReplyTimeout = function (connectionItem, messageId) {
        if (!connectionItem.replies[messageId])
            return;
        clearTimeout(connectionItem.replies[messageId].deleteTimeoutTimer);
    };
    DynaNodeClient.prototype._updateConnectionForExpiration = function (connectionItem) {
        var _this = this;
        if (!this._config.closeInactiveConnectionsInMinutes)
            return;
        connectionItem.lastTimeUsed = new Date();
        if (connectionItem.expirationTimeoutHandler !== null)
            clearTimeout(connectionItem.expirationTimeoutHandler);
        if (Object.keys(connectionItem.replies).length === 0) {
            connectionItem.expirationTimeoutHandler = setTimeout(function () {
                if (!connectionItem.connection)
                    return;
                _this._closeConnection(connectionItem.connection.serverAddress, {
                    code: 1810191322,
                    section: 'DynaNodeClient/_updateConnectionForExpiration',
                    message: 'Connection is expired (this is not error)',
                    errorType: dyna_interfaces_1.EErrorType.APP,
                })
                    .catch(function (error) { return console.error("DynaNodeClient " + _this.consolePrefixAddress + ": _updateConnectionForExpiration: 1810194555 Cannot close expired connection", consoleStringify_1.consoleStringify(error)); });
            }, this._config.closeInactiveConnectionsInMinutes * 1000 * 60);
        }
    };
    // trigger the process to close a connection
    DynaNodeClient.prototype._closeConnection = function (serverAddress, error) {
        return __awaiter(this, void 0, void 0, function () {
            var connectionItem, messagesToSend, repliesKeys;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        connectionItem = this._connections[serverAddress];
                        if (!connectionItem)
                            return [2 /*return*/]; // exit, the connection is closed already
                        messagesToSend = [];
                        connectionItem.serverAddresses.forEach(function (serverAddress) { return messagesToSend.concat(_this._messagesToSend[serverAddress] || []); });
                        // reject all pending messages
                        while (messagesToSend.length) {
                            // @ts-ignore
                            messagesToSend.shift().reject(error || unknownError_1.unknownError(1810191206, 'DynaNodeClient/_closeConnection'));
                        }
                        // delete the reference (so will not come again here)
                        delete this._connections[serverAddress];
                        connectionItem.serverAddresses.forEach(function (serverAddress) { return delete _this._validIncomingServerAddresses[serverAddress]; });
                        // clear the timer! otherwise the app will not end immediately
                        if (connectionItem.expirationTimeoutHandler !== null) {
                            clearTimeout(connectionItem.expirationTimeoutHandler);
                        }
                        repliesKeys = Object.keys(connectionItem.replies);
                        if (Object.keys(connectionItem.replies).length) {
                            repliesKeys.forEach(function (repliesKey) {
                                clearTimeout(connectionItem.replies[repliesKey].deleteTimeoutTimer);
                            });
                            connectionItem.replies = {};
                        }
                        if (!(connectionItem && connectionItem.connection)) return [3 /*break*/, 2];
                        return [4 /*yield*/, connectionItem.connection.disconnect()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    // listen the connection close event
    DynaNodeClient.prototype._handleOnConnectionClose = function (serverAddress) {
        var _this = this;
        this._closeConnection(serverAddress, {
            code: 1810191320,
            section: 'DynaNodeClient/_handleOnConnectionClose',
            message: 'Connection is closed from network layer',
            errorType: dyna_interfaces_1.EErrorType.HW,
        })
            .catch(function (error) { return console.error("DynaNodeClient " + _this.consolePrefixAddress + ": _handleOnConnectionClose: 1810194556 Cannot close connection after hw close", consoleStringify_1.consoleStringify(error)); });
        if (this._config.onConnectionClose)
            this._config.onConnectionClose(serverAddress);
    };
    Object.defineProperty(DynaNodeClient.prototype, "_traceData", {
        get: function () {
            return {
                clientPrefix: this._config.prefixAddress,
            };
        },
        enumerable: true,
        configurable: true
    });
    DynaNodeClient.prototype._debug_dynaNode_monitorTransactions = function (inputOutput, message) {
        if (envGlobal_1.envGlobal._debug_dynaNode_monitorTransactions) {
            this._debug_monitorTransactionsWarnOnce();
            try {
                envGlobal_1.envGlobal._debug_dynaNode_monitorTransactions({
                    date: (new Date).toISOString(),
                    direction: inputOutput,
                    message: message.viewSecure,
                });
            }
            catch (error) {
                console.error("DynaNodeClient " + this.consolePrefixAddress + ": _debug_dynaNode_monitorTransactions: the implementation of your callback raised an error", consoleStringify_1.consoleStringify(error));
            }
        }
    };
    DynaNodeClient.prototype._debug_monitorTransactionsWarnOnce = function () {
        if (!envGlobal_1.envGlobal._debug_dynaNode_monitorTransactions_warned) {
            console.warn("DynaNodeClient " + this.consolePrefixAddress + ": _debug_dynaNode_monitorTransactions has a callback, this should not be active on production!");
            envGlobal_1.envGlobal._debug_dynaNode_monitorTransactions_warned = true;
        }
    };
    Object.defineProperty(DynaNodeClient.prototype, "consolePrefixAddress", {
        get: function () {
            return "[prefixAddress: " + (this._config.prefixAddress || 'not defined') + "]";
        },
        enumerable: true,
        configurable: true
    });
    return DynaNodeClient;
}());
exports.DynaNodeClient = DynaNodeClient;
//# sourceMappingURL=DynaNodeClient.js.map